/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */

/*
* Supervised classification block options:
* - CART: Classification and Regression Trees
* - SVM: Support Vector Machine (requires a set of custom parameters)
* - Random Forest
*/

// Issues:
// - confusion matrix? -- only resubstitution accuracy
// - SVM parameters defaults?
// for defaults, optimal C (regularization cost parameter) and gamma are unknown
// in the future, grid search on C+gamma using cross-validation could be implemented in Python

import * as Blockly from 'blockly/core';
import 'blockly/python';
import { getAllowedOutputs } from '../block_compatibility_checks';
import { AreaService } from '@/services/area.service';

Blockly.Blocks['analyse_supervised_class_selector'] = {
    init: function () {
        let areas = AreaService.getUserAreas();
        this.appendDummyInput('inp')
            .appendField("Class: ")
            .appendField(new Blockly.FieldDropdown(areas), "area")
            .appendField("  Class name: ")
            .appendField(new Blockly.FieldTextInput('class_name', function (newValue) { return newValue.replace(/</g, '').replace(/>/g, '') }),
                'classname');
        this.setPreviousStatement(true, 'sup_class');
        this.setNextStatement(true, getAllowedOutputs('sup_class'));
        this.setStyle('classification');
        this.setTooltip(Blockly.Msg.SUPERVISED_CLASS_BLOCK_TOOLTIP) ;
        this.setHelpUrl("");
    }
}